import React from "react";
import { useAppSelector } from "../../../../app/store";

import { isFinalFICV2Enabled } from "../../../configs/logic/Slice";
import { FICDecisionPage } from "./FICDecisionPage";
import { FICPage } from "../../components/fic/FICPage";

export const FICPageContainer: React.FC = () => {
  
  const isFICV2Enabled = useAppSelector(isFinalFICV2Enabled);

  if (isFICV2Enabled) {
    return <FICDecisionPage/>;
  }

  return <FICPage />;
};